export function repairPartNumberUpdate(
  state = { newPNID: { id: null, partNumber: null } },
  action
) {
  if (action && action.type) {
    switch (action.type) {
      case "NEW_SERIAL_ID":
        return {
          newPNID: {
            id: action.newPNID.id,
            serialNumber: action.newPNID.serialNumber,
            priority: action.newPNID.priority,
          },
        };
      case "NEW_PARTNUMBER_ID":
        return {
          newPNID: {
            id: action.newPNID.id,
            partNumber: action.newPNID.partNumber,
            priority: action.newPNID.priority,
          },
        };
      default:
        return state;
    }
  }
}
